import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http';
import { Observable, Subject } from 'rxjs';

/**
 * @deprecated Will be removed eventually.
 */
export type OnInterceptParams = {
  interceptors: Observable<HttpEvent<unknown>>[];
  /**
   * This can be reassigned by intermediate interceptors
   */
  request: HttpRequest<any>;
  next: HttpHandler;
};

export type InterceptorFn = HttpInterceptor['intercept'];
export type InterceptorFnResult = ReturnType<InterceptorFn>;

export interface ShellWindow {
  mfeShell: MFEShell | undefined;
}

export interface MFEShell {
  /**
   * @deprecated Use registerInteceptor. Will be removed eventually.
   */
  onIntercept: Subject<OnInterceptParams>;
  registerInteceptor: (id: string, interceptorFn: InterceptorFn) => void;
  unregisterInterceptor: (id: string) => void;
  getInterceptors: () => InterceptorFn[];
  isMFE: boolean;
}

const interceptorsMap: Map<string, InterceptorFn> = new Map();

export function initializeGlobals() {
  const shellWindow = window as unknown as ShellWindow;
  shellWindow.mfeShell = {
    onIntercept: new Subject<OnInterceptParams>(),
    registerInteceptor: (id, interceptorFn) => {
      interceptorsMap.set(id, interceptorFn);
    },
    unregisterInterceptor: (id) => {
      interceptorsMap.delete(id);
    },
    getInterceptors: () => {
      // ES6 maps preserve insertion order
      return Array.from(interceptorsMap.values());
    },
    isMFE: true
  };
}

export const shellWindow = window as unknown as ShellWindow;
